// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"MessageList--next-sr-only--3PO0EQj","contentContainer":"MessageList--contentContainer--1Z4i0wE","datePicker":"MessageList--datePicker--10w0csD"};